import React, { useState } from "react";

const noticesData = [
  {
    title: "Final Exam Timetable Released",
    date: "12 Apr 2026",
    category: "Exam Schedules",
  },
  {
    title: "Summer Vacation Starts Soon",
    date: "10 Apr 2026",
    category: "Holidays",
  },
  {
    title: "Sports Day Registration Open",
    date: "08 Apr 2026",
    category: "Events",
  },
  {
    title: "New Library Books Available",
    date: "05 Apr 2026",
    category: "Important Updates",
  },
  {
    title: "Independence Day Holiday Notice",
    date: "03 Apr 2026",
    category: "Holidays",
  },
];

export default function Notices() {
  const [activeCategory, setActiveCategory] = useState("All");

  const filteredNotices =
    activeCategory === "All"
      ? noticesData
      : noticesData.filter(
        (notice) => notice.category === activeCategory
      );

  return (
    <>
      <style>{`
        .notice-page {
          padding: 30px;
          background: #f4f6f9;
          min-height: 100vh;
          font-family: 'Segoe UI', sans-serif;
        }

        .notice-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 20px;
        }

        .notice-title {
          font-size: 26px;
          font-weight: 600;
          color: #1e3a8a;
        }

        .category-bar {
          display: flex;
          gap: 10px;
          flex-wrap: wrap;
        }

        .category-btn {
          background: white;
          border: 1px solid #d1d5db;
          padding: 8px 16px;
          border-radius: 6px;
          font-weight: 500;
          cursor: pointer;
          transition: 0.3s;
        }

        .category-btn.active {
          background: #1e3a8a;
          color: white;
          border-color: #1e3a8a;
        }

        .category-btn:hover {
          background: #1e3a8a;
          color: white;
        }

        .notice-table-container {
          background: white;
          border-radius: 10px;
          overflow: hidden;
          box-shadow: 0 4px 12px rgba(0,0,0,0.08);
        }

        table {
          width: 100%;
          border-collapse: collapse;
        }

        thead {
          background: #1e3a8a;
          color: white;
        }

        th, td {
          padding: 14px 16px;
          text-align: left;
        }

        tbody tr {
          border-bottom: 1px solid #e5e7eb;
          transition: 0.2s;
        }

        tbody tr:hover {
          background: #f9fafb;
        }

        .serial {
          width: 60px;
          text-align: center;
          color: #6b7280;
        }

        .notice-text {
          font-weight: 500;
          color: #111827;
        }

        .notice-date {
          color: #374151;
          font-size: 14px;
        }

        /* Category Colors */
        .badge {
          padding: 4px 10px;
          border-radius: 6px;
          font-size: 12px;
          font-weight: 500;
        }

        .important {
          background: #fee2e2;
          color: #b91c1c;
        }

        .events {
          background: #dcfce7;
          color: #166534;
        }

        .holidays {
          background: #e0f2fe;
          color: #0369a1;
        }

        .exam {
          background: #fef3c7;
          color: #92400e;
        }
      `}</style>

      <div className="notice-page">
        <div className="notice-header">
          <div className="notice-title">Notices & Announcements</div>

          {/* Category Buttons */}
          <div className="category-bar">
            {["All", "Important Updates", "Events", "Holidays", "Exam Schedules"].map(
              (cat) => (
                <button
                  key={cat}
                  className={`category-btn ${activeCategory === cat ? "active" : ""
                    }`}
                  onClick={() => setActiveCategory(cat)}
                >
                  {cat}
                </button>
              )
            )}
          </div>
        </div>

        <div className="notice-table-container">
          <table>
            <thead>
              <tr>
                <th className="serial">#</th>
                <th>Notice Title</th>
                <th>Date</th>
                <th>Category</th>
              </tr>
            </thead>

            <tbody>
              {filteredNotices.map((notice, index) => {
                let badgeClass = "";

                if (notice.category === "Important Updates") badgeClass = "important";
                if (notice.category === "Events") badgeClass = "events";
                if (notice.category === "Holidays") badgeClass = "holidays";
                if (notice.category === "Exam Schedules") badgeClass = "exam";

                return (
                  <tr key={index}>
                    <td className="serial">{index + 1}</td>
                    <td className="notice-text">{notice.title}</td>
                    <td className="notice-date">{notice.date}</td>
                    <td>
                      <span className={`badge ${badgeClass}`}>
                        {notice.category}
                      </span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}